import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import './footer.scss';
import theme from '../../theme';
import { Link } from 'react-router-dom';

/**
 * Composant pour le footer des pages
 *
 * @constructor
 */
export default function Footer() {
    const color = theme.palette.blue.main;
    const linkStyle = {
        color: color,
    };
    // Création du footer
    return (
        <Box
            className="container-footer"
            sx={{
                borderTop: 'solid 1px ',
                borderColor: theme.palette.blue.main,
            }}
        >
            {/*Mise en place des liens*/}
            {/*- RGPD*/}
            {/*- Mentions-legales*/}
            <Stack
                direction={{ xs: 'row' }}
                justifyContent="space-evenly"
                alignItems="center"
                useFlexGap
                flexWrap="wrap"
                spacing={{ xs: 2, md: 4 }}
            >
                {/* Bouton mentions légales */}
                <Button variant="text">
                    <Link className="link" to={'/mentions-legales'} style={linkStyle}>
                        Mentions légales
                    </Link>
                </Button>
                {/* Bouton RGPD */}
                <Button variant="text">
                    <Link className="link" to={'/donnees-personnelles'} style={linkStyle}>
                        Données personnelles
                    </Link>
                </Button>
                {/* Bouton CGU */}
                <Button variant="text">
                    <Link className="link" to={'/cgu'} style={linkStyle}>
                        CGU
                    </Link>
                </Button>
                {/* Bouton Gestion des cookies */}
                <Button variant="text">
                    <Link className="link" to={'/gestion-cookies'} style={linkStyle}>
                        Gestion des cookies
                    </Link>
                </Button>
                {/* Bouton contactez-nous */}
                <Button variant={'text'}>
                    <Link to={'/contactez-nous'} className={'link'} style={linkStyle}>
                        Contactez-nous
                    </Link>
                </Button>
            </Stack>
        </Box>
    );
}
